import { PropsWithChildren, useEffect } from "react";
import { datadogLogs } from "@datadog/browser-logs";
import { useSessionKf } from "components/auth/lib/useSessionKf";
import { downgradeNetworkDropouts } from "./downgradeNetworkDropouts";

export function DatadogLoggerProvider({ children }: PropsWithChildren) {
  useDatadogLogger();
  return <>{children}</>;
}

function useDatadogLogger() {
  const { session } = useSessionKf();

  useEffect(() => {
    if (globalThis.__ENV.RUNTIME_PUBLIC_DATADOG_ENV === "disabled") return;
    const isLogsInitialized = datadogLogs.getInitConfiguration() !== undefined;
    if (!isLogsInitialized) initDatadogLogs();
    const user = datadogLogs.getUser();
    if (!!session?.user) {
      if (user === undefined || user.id !== session.user.sub)
        datadogLogs.setUser({
          id: session.user.sub,
          name: session.user.name,
          email: session.user.email,
        });
    } else {
      if (user !== undefined) datadogLogs.clearUser();
    }
  }, [session?.user]);
}

function initDatadogLogs() {
  datadogLogs.init({
    site: "datadoghq.com",
    clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
    service: process.env.NEXT_PUBLIC_DATADOG_SERVICE,
    env: globalThis.__ENV.RUNTIME_PUBLIC_DATADOG_ENV,
    version: globalThis.__ENV.RUNTIME_PUBLIC_APP_VERSION,
    forwardErrorsToLogs: true, //console.error logs, uncaught exceptions and network errors
    forwardConsoleLogs: [], //console.* logs
    sessionSampleRate: 100,
    useSecureSessionCookie: true,
    beforeSend: downgradeNetworkDropouts,
  });
}
